import React, { Component } from 'react';
import { Tabs, Tab, Grid, Row, Col, FormGroup, ControlLabel, FormControl, Table, Panel, ButtonToolbar, Button, Radio } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { Notes } from '../native/tabs/Notes';
import { SortIndicator } from '../../../SortIndicator';
import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { LinesCommand } from '../../commands/LinesCommand';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';
import { LayoutCommand } from '../../commands/LayoutCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';

export class SmtucScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            dependencies: {
                lines: [],
                schedules: [],
                setOfDayTypes: [],
                layouts: [],
                stops: [],
                complementaryStops: [],
            },
            validations: {
                schedulesComponents: [
                    "DayTimesheet",
                    "DayVerticalTimesheet",
                    "CompactDayTimesheet",
                    "VerticalDayTimesheet",
                    "HorizontalTabularDayTimesheet",
                    "VerticalTabularDayTimesheet",
                    "VerticalComposedDayTimesheet"
                ]
            },
            form: {
                layout: undefined,
                line: undefined,
                complementaryLines: [],
                referenceDate: new Date().toISOString(),
                sets: {},
                schedules: {},
                stops: [],
                type: 1,
            },
            render: {
                tab: 1,
                layouts: [],
                schedules: [],
                schedulesComponents: [],
                notesComponents: [],
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new LinesCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand(),
                layouts: new LayoutCommand(),
                stops: new PathStopsCommand(),
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isLoadingStops: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getSetOfDayTypes();
        this.getLayouts();

        const edition = this.context.getOwnEdition();
        edition.addObserver(this);
        edition.updateSync(new Date())

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        this.startUpdate();

        const { actions, form } = this.state;

        actions.isLoadingLines = true;
        form.line = undefined;

        this.setState({
            form: form,
            actions: actions
        }, () => {
            this.getLines(this.state.edition);
            this.onChangeLineSelected(); 
            this.endUpdate();
        });
    }

    updatePlanning() {
        const { actions, render } = this.state;

        actions.isLoadingSchedules = true;
        render.schedules = [];

        this.setState({
            actions: actions,
            render: render
        }, () => {
            this.getSchedules(this.state.edition);
        });
    }

    // ----------------------

    getLayouts() {
        const { actions, commands } = this.state;
        commands.layouts.list(
            (a) => this.listSuccessCallback(a, "layouts", "isLoadingLayouts", () => this.appendLayouts()),
            (a) => this.listErrorCallback(a, "layouts", "isLoadingLayouts")
        );

        actions.isLoadingLayouts = true;

        this.setState({
            actions: actions
        });
    }

    appendLayouts() {
        const { dependencies, render } = this.state;

        const hardCodedLayouts = [
            { id: -1, name: "Horário de Linha" },
            { id: -2, name: "Horário de Bolso" }
        ];

        dependencies["layouts"] = [...hardCodedLayouts, ...dependencies["layouts"]];
        render["layouts"] = dependencies["layouts"];

        this.setState({
            dependencies: dependencies,
            render: render
        });
    }

    getLines(edition) {
        const { actions, commands } = this.state;
        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines"),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        const { actions, commands } = this.state;

        commands.setOfDayTypes.listFull(
            (a) => this.listSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        actions.isLoadingSetOfDayTypes = true;

        this.setState({
            actions: actions
        });
    }

    getStops(edition) {
        const { form, actions, commands } = this.state;

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });

        commands.stops.listStops(
            edition.network,
            form.line.id,
            (a) => this.listSuccessCallback(a, "stops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, "stops", "isLoadingStops")
        );
    }

    getComplementaryStops(edition) {
        const { form, actions, commands } = this.state;

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });

        const complementaryLinesIds = form.complementaryLines.map(line => line.id);

        commands.stops.listComplementaryStops(
            edition.network,
            complementaryLinesIds,
            (a) => this.listSuccessCallback(a, "complementaryStops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, "complementaryStops", "isLoadingStops")
        );
    }

    getSchedules(edition) {
        const { actions, commands } = this.state;

        commands.schedules.list(
            edition.planning,
            (a) => this.listSuccessCallback(a, "schedules", "isLoadingSchedules", () => this.filterSchedules()),
            (a) => this.listErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypesSubsets(setOfDayTypes, setOfDayTypesId) {
        const selectedSetOfDayTypes = setOfDayTypes.find(dT => dT.id === setOfDayTypesId);
        const subsets = [];

        if (undefined !== selectedSetOfDayTypes) {
            setOfDayTypes.forEach(set => {
                if (setOfDayTypesId !== set.id) {
                    const dayTypes = set.dayTypes;
                    let output = false;

                    dayTypes.forEach(dayType => {
                        output |= undefined !== selectedSetOfDayTypes.dayTypes.find(setDayType => setDayType.id === dayType.id);
                    });

                    if (output) {
                        subsets.push(set.id);
                    }
                }
            });
        }

        return subsets;
    }

    getScheduleClassName(form, componentId, schedule, setOfDayTypesId) {
        if (undefined === form.line) {
            return "";
        }

        const objKey = `${form.line.code}-${componentId}-${form.type}-${setOfDayTypesId}`;
        if (undefined === form.schedules[objKey]) {
            return "";
        }

        return undefined === form.schedules[objKey].find(s => s === schedule.id) ?
            "" :
            "checked";
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;

        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    onSelectLineScheduleType() {
        const { render } = this.state;

        if (1 === render.tab) {
            render.tab = 2;
        }

        this.setState({
            render: render
        });
    }

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    onSelectAllStops() {
        const { dependencies, form } = this.state;

        var full = form.stops.length === dependencies.stops.length;

        form.stops = [];
        if (!full) {
            dependencies.stops.forEach(stop => form.stops.push(stop));
        }

        this.setState({
            form: form
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onStopRowClick(stop) {
        const { form } = this.state;
        const index = form.stops.findIndex(s => s.code === stop.code);

        if (index === -1) {
            form.stops.push(stop);
        }
        else {
            form.stops = form.stops.slice(0, index).concat(form.stops.slice(index + 1, form.stops.length));
        }

        this.setState({
            form: form
        });
    }

    onChangeReferenceDateValue(date) {
        const { form } = this.state;

        form.referenceDate = date;

        this.setState({
            form: form,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onSelectAllSchedules(set, setOfDayTypesSchedules) {
        const { form } = this.state;
        const setOfDayTypesSchedulesIds = setOfDayTypesSchedules.map(setSchedule => setSchedule.id);

        if (undefined === form.sets[set] || !setOfDayTypesSchedulesIds.every(setScheduleId => form.sets[set].schedules.includes(setScheduleId))) {
            form.sets[set] = {
                order: -1,
                heightRatio: 1,
                schedules: setOfDayTypesSchedulesIds.map(scheduleId => scheduleId)
            };
        }
        else {
            form.sets[set].schedules = form.sets[set].schedules
                .filter(schedule => !setOfDayTypesSchedulesIds.includes(schedule));
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onSelectAllSchedulesNative(component, setOfDayTypesId) {
        const { form } = this.state;

        const objKey = `${form.line.code}-${component.componentId}-${form.type}-${setOfDayTypesId.id}`;

        let remove = true;

        //If the component doesn't exist in the dictionary, create with the correct format
        if (!Array.isArray(form.schedules[objKey])) {
            form.schedules = Object.assign(form.schedules, { [objKey]: [] });
        }

        //Check if any schedules are missing from the selection. If so, add them and don't delete any schedules.
        component.schedules.forEach(function (sched) {
            if (-1 === form.schedules[objKey].findIndex(s => s === sched.id)) {
                remove = false;
                form.schedules[objKey].push(sched.id);
            }
        });

        //If remove === true this means that we have to remove the schedType schedules from selectedSchedules
        if (remove) {
            component.schedules.forEach(function (sched) {
                let index = form.schedules[objKey].findIndex(s => s === sched.id);
                if (index !== -1) {
                    form.schedules[objKey].splice(index, 1);
                }
            });
        }

        this.setState({
            form: form,
        });
    }

    onScheduleRowClick(set, schedule) {
        const { form } = this.state;

        if (undefined === form.sets[set]) {
            form.sets[set] = {
                order: -1,
                heightRatio: 1,
                schedules: [schedule]
            };
        }
        else if (form.sets[set].schedules.includes(schedule)) {
            form.sets[set].schedules = form.sets[set].schedules
                .filter(setSchedule => setSchedule !== schedule);
        }
        else {
            form.sets[set].schedules.push(schedule);
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onScheduleRowClickNative(schedule, component, setOfDayTypesId) {
        const { form } = this.state;

        const objKey = `${form.line.code}-${component}-${form.type}-${setOfDayTypesId}`;
        if (undefined === form.schedules) {
            form.schedules = {};
        }

        if (!Array.isArray(form.schedules[objKey])) {
            form.schedules[objKey] = [];
        }

        const schedIndex = form.schedules[objKey].indexOf(schedule.id);
        if (schedIndex === -1) {
            form.schedules[objKey].push(schedule.id);
        } else {
            form.schedules[objKey].splice(schedIndex, 1);
        }

        this.setState({ form: form });
    }

    onGenerateClick() {
        const { form, render } = this.state;

        if (undefined === form.layout || null === form.layout) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar um layout.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (undefined === form.line || null === form.line) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar uma linha.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        const isScheduleNotSelected = form.layout.id === -1 || form.layout.id === -2
                ? form.sets.length === 0 || Object.values(form.sets).every(set => set.schedules.length === 0)
                : Object.keys(form.schedules).length === 0;


        if (isScheduleNotSelected) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos um horário.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if (form.type === 1 && form.stops.length === 0 && (form.layout.id !== -1 && form.layout.id !== -2)) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos uma paragem.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        if(undefined === form.layout.id || null === form.layout.id) {
            actions.isGenerating = false;
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Layout selecionado inválido.",
                    style: "warning",
                    icon: "alert"
                },
                actions: actions
            });

            return;
        }

        const { actions, commands } = this.state;
        const data = {
                lineId: form.line.id,
                complementaryLinesIds: Array.isArray(form.complementaryLines) ? form.complementaryLines.map(line => line.id) : [],
                Notes: render.notesComponents.map(component => Object.assign({}, { componentId: component.id, notes: component.notes })),
                lineCode: form.line.code,
                componentSchedules: {},
                referenceDate: form.referenceDate,
                sets: form.sets
        };

        for (let objKey in form.schedules) {
            const keyData = objKey.split("-");
            const componentId = keyData[1];
            const setId = keyData[3];

            this.filterAllowedSchedules(componentId, objKey);

            if(undefined === data.componentSchedules[componentId]) {
                data.componentSchedules[componentId] = {};
            }
            data.componentSchedules[componentId][setId] = form.schedules[objKey];
        }

        actions.isGenerating = true;

        switch (form.layout.id) {
            case -1:
                commands.draw.generateSmtucLineSched(
                    data,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
                break;

            case -2:
                commands.draw.generateSmtucPocketSched(
                    data,
                    (a) => this.generationSuccessCallback(a),
                    (a) => this.generationErrorCallback(a)
                );
                break;

            default:
                if (form.type === 1) {
                    data.stops = form.stops;
                    commands.draw.generateBusSched(
                        form.layout,
                        data,
                        (a) => this.generationSuccessCallback(a),
                        (a) => this.generationErrorCallback(a)
                    );
                } else {
                    commands.draw.generateLineSched(
                        form.layout,
                        data,
                        (a) => this.generationSuccessCallback(a),
                        (a) => this.generationErrorCallback(a)
                    );
                }
        }

        this.setState({
            actions: actions
        });
    }

    onChangeSetHeightRatioValue(e, set) {
        const { form } = this.state;

        if (undefined === form.sets[set]) {
            form.sets[set] = {
                order: -1,
                heightRatio: e.target.value,
                schedules: []
            };
        }
        else {
            form.sets[set].heightRatio = e.target.value;
        }

        this.setState({
            form: form
        }, () => {
            this.sortFormSets();
        });
    }

    onChangeLineSelected() {
        const { form, edition } = this.state;
        

        if (undefined === form.line || null === form.line) {
            form.sets = {};
        }
        else {
            this.getStops(edition);
            this.filterSchedules();
        }

        if(0 !== form.complementaryLines.length) {
            this.getComplementaryStops(edition);
        }

        this.setState({
            form: form
        });
    }

    onChangeNotes(e, componentId) {
        const { render } = this.state;

        const component = render.notesComponents
            .find(c => c.id === componentId);

        if (undefined !== component) {
            component.notes = e.target.value;
        }

        this.setState({
            render: render
        });
    }

    onChangeLayoutSelected() {
        const { dependencies, form, validations, render } = this.state;

        render.setOfDayTypes = [];
        render.schedulesComponents = [];
        let layoutDayTimesheetComponents = [];
        let setOfDayTypesCustomObjects = [];

        if(undefined !== form.layout && (form.layout.id === -1 || form.layout.id === -2)) {
            render.tab = 1;
        }

        if (undefined !== form.layout && (form.layout.id !== -1 && form.layout.id !== -2)) {
            // Schedules
            layoutDayTimesheetComponents = form.layout.components
                .filter(comp => validations.schedulesComponents.includes(comp.type));

            layoutDayTimesheetComponents.forEach((comp) => {
                if (!comp.dataIdentifier) {
                    return;
                }

                const componentId = comp.id;
                const dataIdentifierNumbers = comp.dataIdentifier.split('|%|')[0]
                    .split(',')
                    .map(identifier => parseInt(identifier, 10));

                let configuration = JSON.parse(comp.configuration);
                if(undefined === configuration || null === configuration || undefined === configuration.descriptionPt || null === configuration.descriptionPt || "" === configuration.descriptionPt) {
                    configuration = { descriptionPt: "Sem descrição" };
                }

                dataIdentifierNumbers.forEach((dataIdentifierId) => {
                    setOfDayTypesCustomObjects.push({ componentId, setOfDayTypesId: dataIdentifierId });

                    //Get SetOfDayType subsets
                    const subsets = this.getSetOfDayTypesSubsets(dependencies.setOfDayTypes, dataIdentifierId);

                    render.schedulesComponents.push({
                        componentId: componentId, 
                        setOfDayTypesId: dataIdentifierId, 
                        subsets: subsets, 
                        schedules: [], 
                        description: configuration.descriptionPt 
                    });
                });
            });

            setOfDayTypesCustomObjects.forEach((set) => {
                const setOfDayTypesObj = dependencies.setOfDayTypes.find(dT => dT.id === set.setOfDayTypesId);
                if (undefined !== setOfDayTypesObj) {
                    render.setOfDayTypes.push(setOfDayTypesObj);

                    //Add the scheduleList to the correct schedules object, keeping in mind the schedules that might belong to a subset
                    render.schedulesComponents
                        .filter(component => component.dayTypeComponentId === set.dayTypeComponentId && component.setOfDayTypesId === set.setOfDayTypesId)
                        .forEach(component => component.schedules = dependencies.schedules.filter(sched =>
                            undefined !== sched.setOfDayTypes &&
                            (
                                sched.setOfDayTypes.id === set.setOfDayTypesId ||
                                -1 !== component.subsets.findIndex(sub => sub === sched.setOfDayTypes.id)
                            )
                        ));
                }
            });

            // Notes
            render.notesComponents = form.layout.components
                .filter(comp => comp.type === 'Notes')
                .map(comp => Object.assign({ notes: "" }, comp));
        }

        this.setState({
            render: render
        });
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e, idx) {
        e.dataTransfer.setData('index', idx);
    }

    onDrop(e) {
        const oldIndex = e.dataTransfer.getData('index');
        const newIndex = e.target.dataset.value;

        if (undefined !== oldIndex && undefined !== newIndex && oldIndex !== newIndex) {
            const { dependencies } = this.state;

            const oldIndexValue = dependencies.setOfDayTypes[oldIndex];

            dependencies.setOfDayTypes.splice(oldIndex, 1);
            dependencies.setOfDayTypes.splice(newIndex, 0, oldIndexValue);

            this.setState({
                dependencies: dependencies
            }, () => {
                this.sortFormSets();
            });
        }
    }

    // ----------------------

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    sortFormSets() {
        const { dependencies, form } = this.state;

        form.sets = dependencies.setOfDayTypes
            .reduce((output, set) => {
                if (undefined !== output.sets[set.id]) {
                    output.sets[set.id].order = output.order++;
                }

                return output;
            }, { sets: form.sets, order: 0 })
            .sets;

        this.setState({
            form: form
        });
    }

    filterSchedules() {
        const { form, dependencies, render } = this.state;

        if (undefined === form.line) {
            render.schedules = [];
        }
        else {
            const complementaryLinesIds = Array.isArray(form.complementaryLines) ? form.complementaryLines.map(line => line.id) : [];
            render.schedules = dependencies.schedules
                .filter(schedule => Array.isArray(schedule.lines) && (schedule.lines.includes(form.line.id) || schedule.lines.some(scheduleLine => complementaryLinesIds.includes(scheduleLine))));
        }
        form.sets = {};

        this.setState({
            render: render,
            form: form
        });
    }

    filterAllowedSchedules(componentId, objKey) {
        const { render, form} = this.state;

        for (let schedIndex in render.schedulesComponents) {
            if (render.schedulesComponents[schedIndex].componentId !== componentId) {
                continue;
            }

            form.schedules[objKey] = form.schedules[objKey].reduce((output, schedId) => {
                let filteredSchedules = render.schedulesComponents[schedIndex].schedules
                    .filter((schedule) => schedule.id === schedId)
                    .map(schedule => schedule.id);

                if (filteredSchedules.length !== 0) {
                    output.push(...filteredSchedules);
                }

                return output;
            }, []);
        }
    }

    // ----------------------

    renderSetOfDayTypesLabel(setOfDayTypes) {
        if (undefined === setOfDayTypes) {
            return null;
        }

        return (
            <div className="margin-top-15 padding-top-7 control-label">
                {setOfDayTypes.name}
            </div>
        );
    }

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderForm() {
        const { dependencies, render, form } = this.state;

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={() => "Sem Layouts Configurados"}
                                onChange={(e) => this.onSelectValue(e, "layout", () => this.onChangeLayoutSelected())}
                                options={render.layouts}
                                isMulti={false}
                                isClearable={false}
                                isOptionSelected={function (a) {
                                    if(undefined !== form.layout) {
                                        return form.layout.id === a.id;
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.layout}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linha Principal</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.onSelectValue(e, "line", (a) => { this.onChangeLineSelected(a); })}
                                options={dependencies.lines}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.line === a.id;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.line}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linhas Complementares</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linhas complementares selecionadas"
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.onSelectValue(e, "complementaryLines", (a) => { this.onChangeLineSelected(a); })}
                                options={dependencies.lines.filter(line => line !== form.line)}
                                isMulti={true}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.complementaryLines.includes(a);
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.complementaryLines}
                            />
                        </Col>
                    </Row>

                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={(e) => this.onChangeReferenceDateValue(e)} />
                        </Col>
                    </Row>
                    {undefined !== form.layout && (form.layout.id !== -1 && form.layout.id !== -2) ? (
                        <Row className="padding-top-7">
                            <Col sm={3} md={2}>
                                <ControlLabel className="padding-top-10">Tipo de horário</ControlLabel>
                            </Col>
                            <Col sm={9} md={10}>
                                <Radio key={1}
                                    className="padding-top-7"
                                    checked={form.type === 1}
                                    onChange={() => this.onSelectValue(1, "type")}
                                    inline >
                                    Horário de Paragem
                                </Radio>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <Radio key={2}
                                    className="padding-top-7 no-margin-left"
                                    checked={form.type === 2}
                                    onChange={() => this.onSelectValue(2, "type", () => { this.onSelectLineScheduleType() })}
                                    inline >
                                    Horário de Linha
                                </Radio>
                            </Col>
                        </Row>
                    ) : null}
                </FormGroup>
            </Grid>
        );
    }

    renderNativeSchedulesTab() {
        const { render, form } = this.state;
        
        if (undefined === form.line) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title> Atenção </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body> Linha não selecionada</Panel.Body>
                </Panel>
            );
        }

        if(undefined === form.layout) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title> Atenção </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body> Layout não selecionado</Panel.Body>
                </Panel>
            );
        }

        if (0 === render.schedulesComponents.length || 0 === render.setOfDayTypes.length) {
            return (
                <Panel key="semLayout" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title> Atenção </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body> Tipos de dia não configurados no Layout</Panel.Body>
                </Panel>
            );
        }

        const { edition } = this.state;

        return (
            <div>
                {
                    render.schedulesComponents.map((component, idx) => <Grid key={`day-type-schedules-${idx}`} fluid>
                        <Row>
                            <Col sm={2}>
                                {this.renderSetOfDayTypesLabel(render.setOfDayTypes[idx], component)}
                            </Col>
                            <Col sm={10} className="table-small-screens">
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th className="width-70p">Nome</th>
                                            <th className="width-30p">Edição</th>
                                            <th><Button bsSize="small" bsStyle="default" className="pull-right" onClick={() => this.onSelectAllSchedulesNative(component, render.setOfDayTypes[idx])}>SELECIONAR TUDO</Button></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderComponentSchedules(edition, form, component)}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Grid>
                    )
                }
            </div>
        );
    }

    renderSchedule(edition, form, component, schedule, index) {
        return (
            <tr key={`sched-${index}`}
                className={`busched selectable ${this.getScheduleClassName(form, component.componentId, schedule, component.setOfDayTypesId)}`}
                onClick={() => this.onScheduleRowClickNative(schedule, component.componentId, component.setOfDayTypesId)}>
                <td>{schedule.name}</td>
                <td colSpan={2}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
            </tr>
        );
    }

    renderComponentSchedules(edition, form, component) {
        const componentLineSchedules = component.schedules
            .filter(schedule => schedule.lines.includes(form.line.id));

        if(undefined === componentLineSchedules || null === componentLineSchedules || 0 === componentLineSchedules.length) {
            return (
                <tr className="busched">
                    <td colSpan={3}>
                        <span>Sem horários disponíveis para selecionar</span>
                    </td>
                </tr>
            );
        }

        return (
            <React.Fragment>
                {componentLineSchedules.map((schedule, index) => this.renderSchedule(edition, form, component, schedule, index))}
            </React.Fragment>
        );
    }

    renderOrientationLabel(orientation) {
        switch (orientation) {
            case 'C': return "Circular";
            case 'R': return "Volta";
            case 'G': return "Ida";
            case undefined: return "Não Definido";
            default: return "Ambos";
        }
    }

    renderStopsTab(scheduleType, mainStops, complementaryStops, selectedStops) {
        const { sort } = this.state;

        if (2 === scheduleType) {
            return null;
        }

        const stopsList = [...new Map([...complementaryStops, ...mainStops].map(stop => [stop.id, stop])).values()];

        return (
            <Tab eventKey={1} key="geral" title="Paragens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th className="width-20p" onClick={() => this.onChangeSort('code')}>
                                Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-60p" onClick={() => this.onChangeSort('name')}>
                                Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                            </th>
                            <th className="width-20p">
                                Orientação
                            </th>
                            <th>
                                Linha Complementar
                            </th>
                            <th>
                                <Button bsSize="small" className="pull-right" onClick={() => this.onSelectAllStops()}>SELECIONAR TUDO</Button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            stopsList.sort((a, b) => this.sort(a, b)).map((stop, idx) =>
                                <tr key={`stop-${idx}`}
                                    className={`busched selectable ${selectedStops.findIndex(s => s.code === stop.code) !== -1 ? "checked" : ""}`}
                                    onClick={() => this.onStopRowClick(stop)}>
                                    <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                    <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                    <td colSpan={2}>{this.renderOrientationLabel(stop.orientation)}</td>
                                    <td colSpan={2}>{Array.isArray(stop.complementaryLine) && stop.complementaryLine.length > 0 
                                        ? stop.complementaryLine.join(' | ') 
                                        : ''}
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Tab>
        );
    }


    renderBody() {
        const { form, dependencies } = this.state;
        const { render, actions } = this.state;

        if(undefined === form.line || null === form.line || undefined === form.layout || null === form.layout) {
            return null;
        }

        if(form.layout.id === -1 || form.layout.id === -2) {
            return (
                <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                    <Tab eventKey={1} key="sched" title="Horários">
                        {this.renderSchedulesTab()}
                    </Tab>
                </Tabs>
            );
        }

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                {actions.isLoadingStops ? <LoadingSpinner /> :
                this.renderStopsTab(form.type, dependencies.stops, dependencies.complementaryStops, form.stops)}

                <Tab eventKey={2} key="sched" title="Horários">
                    {this.renderNativeSchedulesTab()}
                </Tab>

                <Tab eventKey={3} key="notes" title="Observações" className="padding-15">
                    <Notes components={render.notesComponents}
                        onChange={(a, b) => this.onChangeNotes(a, b)} />
                </Tab>
            </Tabs>
        );

    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                <TitleRow title="Gerar Horário" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLines || actions.isLoadingSetOfDayTypes)}
                {this.renderGeneratingFeedback(actions.isGenerating)}
                {this.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/smtuc/SmtucScheduleGenerator.js